export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('DisplayOptions', () => {
        return {
          displayingClasses: ' hidden md:hidden lg:hidden',
          replaceClasses(options = [{ value: 'default' }]) {
            for (const option of options) {
              if (option.value === 'default') {
                this.displayingClasses = 'block';
                break;
              }
              this.updateClasses(option.value);
            }
          },
          updateClasses(value) {
            const replaceDisplayingClasses = {
              mobile: this.displayingClasses.replace(' hidden', 'block'),
              tablet: this.displayingClasses.replace('md:hidden', 'md:block'),
              desktop: this.displayingClasses.replace('lg:hidden', 'lg:block'),
            }[value];

            this.displayingClasses = replaceDisplayingClasses;
          },
        };
      });
    });
  },
};
